<template>
  <div class="nao-encontrado">
    <nav-menu></nav-menu>

    <div class="w3-main w3-animate-left" style="margin-top:43px;">
      <header class="w3-container" style="padding-top:22px">
        <h5 class="texto-vermelho"><b><i class="fa fa-minus-circle"></i> Não encontrado</b></h5>
      </header>

      <div class="w3-container">
        <div class="w3-row">
            <span class="texto-cinza">A página que você procurava não foi encontrada!</span>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
  import NavMenu from '@/components/Menu'
  export default {
    name: 'NaoEncontrado',
    components: {
      NavMenu
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NaoEncontrado.vue